import { gql } from '@apollo/client';
import useGQLMutation from 'src/lib/graphql/hooks/useGQLMutation';
import { SUBJECT_LIST_QUERY } from './getList';
const UPDATE_SUBJECT_MUTATION = gql `
  mutation EP_UpdateSubject($subjectID: ID!, $data: EPSubjectUpdateInput!) {
    ep_updateSubject(subjectID: $subjectID, data: $data) {
      id
      data {
        title
        description
      }
      type
      attributes {
        totalQuestionCount
        answeredQuestionCount
      }
    }
  }
`;
export function useUpdateSubjectMutation(options) {
    return useGQLMutation(UPDATE_SUBJECT_MUTATION, {
        animateOnSuccess: true,
        ...options,
        update(cache, { data }, { variables, context }) {
            if (!data?.ep_updateSubject || !variables || !context?.examLevelID) {
                return;
            }
            cache.updateQuery({
                query: SUBJECT_LIST_QUERY,
                variables: {
                    examLevelID: context.examLevelID,
                    type: context.type,
                    pagination: {
                        offset: 0,
                        limit: 50,
                    },
                },
            }, ({ ep_subjectList: existingData }) => ({
                ep_subjectList: {
                    ...existingData,
                    list: existingData.list.map((subject) => subject.id === data.ep_updateSubject.id
                        ? {
                            ...subject,
                            ...data.ep_updateSubject,
                            __typename: 'EPSubject',
                        }
                        : subject),
                },
            }));
        },
    });
}
